<template>
  <v-card style="min-width: 65%; max-width: 80%" elevation="5">
    <v-card-text>
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="4" v-for="feature in features" v-bind:key="feature.name">
            <v-card class="d-flex align-center justify-center px-7 py-5" style="height: 180px !important;" outlined>
              <div>
                <div class="d-flex align-center justify-center">
                  <h3 class="text-center">{{ feature.name }}</h3>
                  <v-chip :color="getStatusColor(feature.status)" text-color="white" class="ml-2" small>
                    <p style="font-size: 13px" class="mb-0">{{ feature.status }}</p>
                  </v-chip>
                </div>
                <p class="text-center mb-0 mt-3">{{ feature.description }}</p>
                <v-row class="mt-3 mb-1" justify="center" align="center">
                  <v-btn @click="vote(feature)" :disabled="alreadyVotedFeature(feature.id)">{{ $t('iWantThis') }} <v-icon class="ml-2" color="black" x-small>fa-heart</v-icon></v-btn>
                </v-row>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "FeaturesList",
  props: {
    features: Array,
    alreadyVoted: Array,
  },
  methods: {
    getStatusColor(status) {
      switch (status) {
        case 'Thinking':
          return '#111111';
        case 'Planning':
          return '#d06600';
        case 'Developing':
          return 'var(--v-darkGreen-base)';
        case 'Testing':
          return '#00186e';
      }
    },
    alreadyVotedFeature(featureId) {
      const found = this.alreadyVoted.find((feature) => feature.featureId === featureId);
      return found !== undefined;
    },
    vote(feature) {
      this.$emit('vote', feature);
    },
  }
}
</script>

<style scoped>

</style>



